import { PipelineClosingsChart } from '@/components/Dashboard/PipelineClosingsChart'
import { PipelineClosedDealsTable } from '@/components/Dashboard/PipelineClosedDealsTable'
import { PipelineContextBanner } from '@/components/Dashboard/PipelineContextBanner'
import { PipelineKpiGrid } from '@/components/Dashboard/PipelineKpiGrid'
import { PipelineWinLossPanel } from '@/components/Dashboard/PipelineWinLossPanel'
import {
  shouldShowPipelineContextBanner,
  type PipelineClosedDealRow,
  type PipelineTabView,
} from '@/components/Dashboard/pipelineTab.utils'

type PipelineTabProps = {
  view: PipelineTabView
  closedDeals: PipelineClosedDealRow[]
  valuesVisible?: boolean
}

export function PipelineTab({ view, closedDeals, valuesVisible = false }: PipelineTabProps) {
  return (
    <div className='space-y-6'>
      <p className='text-sm text-text-muted'>
        Performance de fechamentos no período selecionado — receita, conversão e histórico de
        ganhos.
      </p>

      {shouldShowPipelineContextBanner(view) ? (
        <PipelineContextBanner view={view} valuesVisible={valuesVisible} />
      ) : null}

      <PipelineKpiGrid view={view} valuesVisible={valuesVisible} />

      <div className='grid grid-cols-1 gap-4 xl:grid-cols-3'>
        <div className='xl:col-span-2'>
          <PipelineClosingsChart view={view} valuesVisible={valuesVisible} />
        </div>
        <PipelineWinLossPanel view={view} valuesVisible={valuesVisible} />
      </div>

      <PipelineClosedDealsTable deals={closedDeals} valuesVisible={valuesVisible} />
    </div>
  )
}
